import React from 'react'
import Header from '../components/header/Header'

const Ready = () => {
  return (
    <div className='ready'>
      Sorry.. Ready Yet..
      <Header></Header>
    </div>
  )
}

export default Ready